import { render, staticRenderFns } from "./CookieDisclaimer.vue?vue&type=template&id=3f789a28&scoped=true&"
import script from "./CookieDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CookieDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./CookieDisclaimer.vue?vue&type=style&index=0&id=3f789a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f789a28",
  null
  
)

export default component.exports